// Import environment variables
const { VITE_API_URL: ENV_API_URL, VITE_STRIPE_PUBLISHABLE_KEY } = import.meta.env;

// Determine if we're on the local development machine
const isLocalDevelopmentMachine = (): boolean => {
    if (typeof window === 'undefined') return false;

    // Check if we're on localhost or 127.0.0.1
    return window.location.hostname === 'localhost' ||
         window.location.hostname === '127.0.0.1';
};

// Check if we're being accessed from another device via IP
const isAccessedViaIP = (): boolean => {
    if (typeof window === 'undefined') return false;

    // Check if hostname is an IP address in 192.168.x.x format
    return /^192\.168\.\d+\.\d+$/.test(window.location.hostname);
};

// Global flag to force using localhost for all endpoints - important for auth flows
const FORCE_LOCALHOST = isLocalDevelopmentMachine();

// Base API URL for data endpoints (can be IP-based if accessed remotely)
const determineApiUrl = (): string => {
    // 1. If a URL parameter is specified, use that (useful for testing)
    if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const apiParam = urlParams.get('api_url');
        if (apiParam) {
            return apiParam;
        }
    }

    // 2. When running on local dev machine, always use localhost for auth compatibility
    if (FORCE_LOCALHOST) {
        return 'http://localhost:3000/api';
    }

    // 3. When accessed via IP, but not on local machine, use the IP for API
    if (isAccessedViaIP()) {
        return `http://${window.location.hostname}:3000/api`;
    }

    // 4. Default to the environment variable (for production or fallback)
    return ENV_API_URL;
};

// Special URL specifically for auth endpoints (always use localhost when on dev machine)
const determineAuthUrl = (): string => {
    // Always use localhost for auth endpoints when on development machine
    if (FORCE_LOCALHOST) {
        return 'http://localhost:3000/api';
    }

    // Otherwise use the same URL as regular API endpoints
    return determineApiUrl();
};

// Calculate the API URLs once at module load time
const VITE_API_URL = determineApiUrl();
const VITE_AUTH_API_URL = determineAuthUrl();

export {
    VITE_API_URL,
    VITE_AUTH_API_URL,
    VITE_STRIPE_PUBLISHABLE_KEY,
    isLocalDevelopmentMachine
};
